import { RouterContext } from "@/router";
import { posthog } from "posthog-js";

export const posthogIdentify = (ctx: RouterContext) => {
  posthog.identify(ctx.workosAuth.user?.email, {
    workosUserId: ctx.workosAuth.user?.id,
    workosOrganizationId: ctx.workosAuth.organizationId,
    email: ctx.workosAuth.user?.email,
    firstName: ctx.workosAuth.user?.firstName,
    lastName: ctx.workosAuth.user?.lastName,
    galaxyUserId: ctx.currentUser?.user?.id,
    galaxyTenantId: ctx.currentUser?.user?.currentTenant?.tenant?.id,
    galaxyTenantStatus: ctx.currentUser?.user?.currentTenant?.tenant?.status,
    galaxyUserTenantStatus: ctx.currentUser?.user?.currentTenant?.status,
    galaxyUserTenantAccessLevel: ctx.currentUser?.user?.currentTenant?.accessLevel,
    isGuardianOfTheGalaxy: ctx.currentUser?.user?.isGuardianOfTheGalaxy,
  });
  if (ctx.currentUser?.user?.currentTenant?.tenant?.domain) {
    posthog.group("tenant", ctx.currentUser?.user?.currentTenant?.tenant?.domain, {
      workosOrganizationId: ctx.workosAuth.organizationId,
      name: ctx.currentUser.user.currentTenant.tenant.name,
      domain: ctx.currentUser.user.currentTenant.tenant.domain,
      galaxyTenantId: ctx.currentUser.user.currentTenant.tenant.id,
      galaxyTenantStatus: ctx.currentUser.user.currentTenant.tenant.status,
    });
  }
  posthog.reloadFeatureFlags();
};
